import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'core/store';

export interface ToastProps {
  className?: string;
  text: string;
  actionButtonText?: string;
  scheduleId?: number;
  navUrl?: string;
}

export interface ToastState {
  isOpen: boolean;
  props: ToastProps;
}

const initialState: ToastState = {
  isOpen: false,
  props: {
    text: '',
  },
};

const toastSlice = createSlice({
  name: 'toasts',
  initialState,
  reducers: {
    toastClosed: state => {
      state.isOpen = false;
    },
    toastOpen: (state, action: PayloadAction<ToastProps>) => {
      state.props = action.payload;
      state.isOpen = true;
    },
  },
});

export default toastSlice;
export const selectToastState = (state: RootState): ToastState => state.toasts;

export const { toastClosed, toastOpen } = toastSlice.actions;
